import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import TrendingSection from './components/TrendingSection';
import VideosSection from './components/VideosSection';
import NewsSidebarSection from './components/NewsSidebarSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <header>
        <Navbar />
      </header>
      <main>
        <HeroSection />
        <CategorySection />
        <TrendingSection />
        <VideosSection />
        <NewsSidebarSection />
      </main>
      <Footer />
    </div>
  );
}